import * as ReactDOMClient from "react-dom/client";
import "./index.css";
import App from "./App";
import { WIDGET_RENDER_TARGET_ID } from "config";

const element = document.getElementById(WIDGET_RENDER_TARGET_ID);
if (!element)
  throw new Error(
    `No element with id "${WIDGET_RENDER_TARGET_ID}" was found. Make sure its not misspelled"`
  );

const root = ReactDOMClient.createRoot(element);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
